import * as Yup from 'yup';

export const VALIDATION_SCHEMA = t =>
  Yup.object().shape({
    has_accepted_terms: Yup.bool()
      .oneOf([true], t('validation:field_required'))
      .required(t('validation:field_required')),
  });
